import { Box, Image, Spacer } from '@dtx-company/shared-components/src'
import { LargeProductSuitCardData } from '../types'
import { prismicCachedImage } from '@app/prismic/src/utils'
import CTAButton from './CTAButton'
import PrismicText from '@app/prismic/src/components/PrismicText/PrismicText'
import React from 'react'
import ValuePropsColumns from './ValuePropsColumns'

const LargeProductSuitCard: React.FC<{ data?: LargeProductSuitCardData }> = ({ data }) => {
  if (!data) return null

  const isCreateFlowcodeBtn = data.button_label?.toLowerCase() === 'create a flowcode'
  const isImageRightAligned = data.image_alignment === 'Right'

  return (
    <Box px="46px">
      <Box
        display="grid"
        gridTemplateAreas={'"l r"'}
        gridTemplateColumns={isImageRightAligned ? '45.1% 54.9%' : '54.9% 45.1%'}
        maxWidth="998px"
        mx="auto"
      >
        <Box gridArea={isImageRightAligned ? 'r' : 'l'}>
          <Image src={prismicCachedImage(data.image?.url ?? '')} alt={data.image?.alt ?? ''} />
        </Box>
        <Box
          flexDirection="column"
          maxWidth="486px"
          ml={isImageRightAligned ? 0 : '36px'}
          mr={isImageRightAligned ? '36px' : 0}
          justifyContent="center"
        >
          <Box flexDirection="column">
            {data['logo-title']?.url && (
              <Box flexDirection="column" textAlign="left" width="100%">
                <Image
                  maxWidth="153px"
                  src={prismicCachedImage(data['logo-title']?.url)}
                  alt={data['logo-title']?.alt ?? 'logo'}
                />
                <Spacer mb="16px" />
              </Box>
            )}
            <PrismicText richTextField={data.subheader} variant="display/large" lineHeight="40px" />
            <Spacer mb="16px" />
            <PrismicText richTextField={data.description} variant="body/large" />
            <ValuePropsColumns
              valuePropsText={data.value_props_list}
              valuePropsImages={data.value_props_images}
            />
            <Spacer mb="29px" />
            <Box>
              <CTAButton
                label={data.button_label}
                href={isCreateFlowcodeBtn ? undefined : data.button_href?.url}
                onClick={isCreateFlowcodeBtn ? () => window.scrollTo(0, 0) : undefined}
                variant={data.button_variant}
              />
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  )
}

export default LargeProductSuitCard
